import styled from 'styled-components'

// TODO: remove scrolling at this level
const HorizontalGridDivider = styled.div`
  margin: 0px;
  padding: 0px;
  display: grid;
  grid-template-columns: ${(props) => (props.hidden ? '100%' : '12% 88%')};
  width: 100%;
  height: 100%;
`

export default HorizontalGridDivider
